import { createRouter, createWebHistory } from 'vue-router';
import mainBoard from '../components/mainBoard.vue';
import loggedIn from '../components/loggedIn.vue';
import statsBoard from '../components/statsBoard.vue';
import faqPage from '../components/faqPage.vue';
import statsPage from '../components/stats/StatsPage.vue';
import MainLayout from '@/components/MainLayout.vue';
import adsTest from '../components/adsTest.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // routes that use main layout
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '/',
          name: 'mainBoard',
          component: mainBoard,
        },
        {
          path: '/board/:board_id',
          name: 'board',
          component: mainBoard,
        },
        {
          path: '/faq',
          name: 'faq',
          component: faqPage,
        },
        {
          path: '/stats',
          name: 'statistics',
          component: statsPage,
        },
        {
          path: '/ads-test',
          name: 'adsTest',
          components: {
            default: adsTest,
          },
        },
      ],
    },
    // routes that do not use main layout
    {
      path: '/stats/:board_id',
      name: 'stats',
      component: statsBoard,
    },
    {
      path: '/logged-in',
      name: 'loggedIn',
      component: loggedIn,
    },
  ],
});

export default router;
